import { useEffect, useState } from "react"
import Base from "../layout/LandingPage"
import axiosInstance from "../axiosInstance"

const Amenities = () => {

    const [data, setData] = useState("")

    useEffect(() => {
        // getData()
        //eslint-disable-next-line
    }, [])

    const activity = [
        { name: "Room Service ", description: "Order food and beverages delivered to your room anytime." },
        { name: "Air Conditioning", description: "Relax in a climate-controlled, comfortable environment." },
        { name: "24/7 Front Desk", description: "Our team is available round the clock for assistance." },
        { name: "Free Parking", description: "Hassle-free parking space for all guests." },
        { name: "Housekeeping Service", description: "Enjoy a clean and tidy room every day." },
        { name: "Conference & Banquet Facilities", description: "Host meetings, events, or celebrations with ease." },
        { name: "Banquet Hall", description: "A spacious, well-equipped venue for weddings, corporate events, and celebrations, with modern amenities and catering services." },
        { name: "Breakfast", description: "Start your day with a delicious breakfast served in the comfort of your room or in our restaurant. (Additional Charges)" },
        { name: "Camp Fire", description: "Gather around a warm and cozy campfire, ideal for sharing stories and making memories with friends and family. (Additional Charges)" },
        { name: "Home made Food", description: "Indulge in our home-made food, crafted with love and care, offering a taste of local cuisine. (Additional Charges)" },
        { name: "Travel Guide", description: "Let us help you plan your trip with our expert travel guide, providing you with insider tips and recommendations. (Additional Charges)" },
    ]

    // const getData = () => {
    //     axiosInstance(`api/amenity/`, {
    //         baseURL: "https://greens-hugk.onrender.com/",
    //         method: "GET",
    //     }).then(res => {
    //         setData(res?.data)
    //     }).catch(err => {
    //         getData()
    //         console.log('err: ', err);
    //     })
    // }
    return (
        <>
            <Base>
                <div className="container">
                    <h1 className="title">Amenities</h1>
                    <div>
                        <ol>
                            {
                                activity?.map(res => {
                                    return (
                                        <li style={{ padding: "10px" }}>
                                            <h3>{res?.name}</h3>
                                            <h4>{res?.description}</h4>
                                        </li>
                                    )
                                })
                            }
                        </ol>
                    </div>
                </div>
            </Base>
        </>
    )
}

export default Amenities